import * as React from 'react';
import {Redirect, Switch, Route} from 'react-router-dom';

import {TagsPage} from './tags-page';

export function TagsRoot() {
    return (
        <Switch>
            <Redirect exact={true} from='/setup/tag' to='/setup/tag/company' />
            <Route
                path='/setup/tag/:tab'
                render={(routeProps) => {
                    return <TagsPage {...routeProps} />;
                }}
            />
        </Switch>
    );
}
